import { drawerEdgeResizePlugin } from './drawerEdgeResizePlugin.js';
import { panelDrawerWidthStorage } from '@/ui/adapters/drawerWidth';

export const DEFECT_LIST_DRAWER_WIDTH_STORAGE_KEY = 'solvit-defect-list-drawer-width';
export const DEFECT_LIST_DRAWER_DEFAULT_WIDTH = 370;
export const DEFECT_LIST_DRAWER_MIN_WIDTH = 260;
export const DEFECT_LIST_DRAWER_MAX_WIDTH = 560;

export function clampDefectListDrawerWidth(width) {
  if (
    typeof width === 'number' &&
    !Number.isNaN(width) &&
    width >= DEFECT_LIST_DRAWER_MIN_WIDTH &&
    width <= DEFECT_LIST_DRAWER_MAX_WIDTH
  ) {
    return width;
  }
  return DEFECT_LIST_DRAWER_DEFAULT_WIDTH;
}

export async function readDefectListDrawerWidth() {
  try {
    const saved = await panelDrawerWidthStorage.get(DEFECT_LIST_DRAWER_WIDTH_STORAGE_KEY);
    return clampDefectListDrawerWidth(saved);
  } catch {
    return DEFECT_LIST_DRAWER_DEFAULT_WIDTH;
  }
}

/**
 * 대시보드 DefectListDrawer — 왼쪽 가장자리 드래그로 width 조절 (IndexedDB 저장)
 */
export const defectListDrawerResizePlugin = {
  id: 'defect-list-drawer-resize',

  attach(containerEl, ctx = {}) {
    return drawerEdgeResizePlugin.attach(containerEl, {
      edge: 'left',
      minWidth: DEFECT_LIST_DRAWER_MIN_WIDTH,
      maxWidth: DEFECT_LIST_DRAWER_MAX_WIDTH,
      storageKey: DEFECT_LIST_DRAWER_WIDTH_STORAGE_KEY,
      storage: panelDrawerWidthStorage,
      handleClass: 'drawer-edge-resize-handle defect-list-drawer-resize-handle',
      ...ctx
    });
  }
};
